import { Col } from "reactstrap";
import { H3, P, SVG } from "../../../../AbstractElements";
import ActiveUsersCountries from "./ActiveUsersCountries";

const ActiveUsers = () => {
  return (
    <Col xxl="4" md="6" sm="5" className="col-xl-100 countries-name">
      <div className="user">
        <H3>22.837</H3>
        <P className="d-flex">
          <span className="me-2">Active Users</span>
          <span className="bg-light-success me-1">
            <SVG iconId="arrow-up" />
          </span>
          <span className="font-success">- 36.28%</span>
        </P>
      </div>
      <ActiveUsersCountries />
    </Col>
  );
};

export default ActiveUsers;
